import { Mold } from "./Mold";

/* custom helpers */
import { create, contains, index } from './Helpers.js';

/** ----------------------------------------
    Store Data
 ---------------------------------------- */

export class Store {

    /**
     * @data            stores the initial data
     * @select          stores the selected filters
     * @results         stores the results
     */

    constructor() {
        this.data = {};
        this.selected = {};
        this.results = [];
    }

    /** ----------------------------------------
        Explore Data
     ---------------------------------------- */

    /**
     * This method is used to retrieve data from
     * the data store and return the results. It
     * accepts a string written in the following
     * syntax (example): 'data.items'.
     */

    _explore(value) {
        return value.split('.').reduce((data, value) => !data ? this[value] : Array.isArray(data) ? data[0][value] : data[value], '');
    }

    /** ----------------------------------------
        Set Data
     ---------------------------------------- */

    /**
     * This method can be used to start a new
     * temporary data entry that can be filtered
     * using the Filter class.
     */

    set(data) {
        return new Mold(data);
    }

    /** ----------------------------------------
        Get Data
     ---------------------------------------- */

    /**
     * This method can be used to extract a
     * list of results from the constructor
     * of the store object, the value accepts
     * a string that can be written as
     * data.items.calender for instance.
     */

    get(value) {
        let data = this._explore(value);
        if(data) return new Mold(data);
    }

    /** ----------------------------------------
        Add Data
     ---------------------------------------- */

    /**
     * Method available for adding new results
     * to the results variable, will push new
     * results and skip currently present items
     * to the this.results array.
     */

    add(results, clean = true, store = 'results') {
        if(clean) this.clean(store);

        results.map(item => {
            if(contains(this[store], item)) {
                return;
            }
            this[store].push(item);
        });
    }

    /** ----------------------------------------
        Park Data
     ---------------------------------------- */

    /**
     * The park method will temporary hold data
     * that can be parked in a variable. You can
     * clean the park using the clean method.
     */

    park(results, type) {
        // parkTo is variable because filtering days works with 'temp', and location/genre work with 'results'
        let parkTo = type == 'day' ? 'temp' : 'results';

        if(!this['temp'])
            this['temp'] = [];

        this.add(results, false, parkTo);
    }

    /** ----------------------------------------
        Merge Data
     ---------------------------------------- */

    /**
     * Method available for merging two objects
     * to new result. Can be used for more complex
     * items that need updating.
     */

    merge(object) {
        Object.assign(this.results, object);
    }

    /** ----------------------------------------
        Remove Data
     ---------------------------------------- */

    /**
     * This method can be used to remove items
     * from the results array.
     */

    remove(items, store = 'results') {
        items = typeof items === 'object' ? [items] : items;

        items.map(item => {
            let value = index(this[store], item);
            this[store].splice(value,1);
        });
    }

    /** ----------------------------------------
        Clean Data
     ---------------------------------------- */

    /**
     * The clean method sets the results to a
     * empty array. All previous available items
     * will be lost, be careful what you wish for.
     */

    clean(store = 'results') {
        this[store] = [];
    }

    /** ----------------------------------------
        Reset Data
     ---------------------------------------- */

    /**
     * The reset method will set results to
     * available data or if a selected array
     * or object is given to that particular
     * set of results.
     */

    reset(select) {
        this.results = select ? this.get(select) : this.data;
    }

    /** ----------------------------------------
        Create Entry
     ---------------------------------------- */

    /**
     * To create new stores within the constructor
     * it's possible to use the entry method, it
     * can also be chained using the filter class.
     */

    entry(data, ...name) {
        create(this, 'sander');
        return new Mold(this[['copy']['sander']]);
    }

    /** ----------------------------------------
        Save Data
     ---------------------------------------- */

    /**
     * This function stores the data in a data
     * object that includes the original key
     * given in the configuration.
     */

    save(name, feed) {
        let data = feed[0];
        let info = Object.keys(name);

        for (let i = 0; i < data.length; i++) {
            this.data[info[i]] = data[i].data;
        }
    }
}